import { CommonModule, NgClass, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ParameterRoutes } from './parameters-routes';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { EnumerationCategoryService } from '@digiwall/core';
import { DwSectionGroupingRoutingComponent } from '@digiwall/ui-kit';
import { LocalizationModule } from '@abp/ng.core';

@Component({
  selector: 'document-delivery-management',
  templateUrl: './parameters.component.html',
  styleUrl: './parameters.component.scss',
  styles: [
    `
      :host {
        flex-grow: 1;
      }
    `,
  ],
  imports: [
    CommonModule,
    NgClass,
    NgIf,
    DwSectionGroupingRoutingComponent,
    RouterOutlet,
    LocalizationModule,
  ],
})
export class ParametersComponent {
  parametersRoutes;
  showParametersRoutes: boolean = true;

  constructor(
    private route: ActivatedRoute,
    public enumerationCategoryService: EnumerationCategoryService,
    private router: Router,
  ) {
    this.route.data.subscribe(params => {
      this.parametersRoutes = ParameterRoutes.find(x => x.route == params.category);

      this.enumerationCategoryService.setTitle(
        this.router.events,
        this.parametersRoutes.sections.flatMap(section => section.items),
      );
    });
  }

  onSubRouterActivate(component: Component) {
    (component as any).route?.data?.subscribe(params => {
      this.showParametersRoutes = !params.hideParameters;
    });
  }
}
